export const setQueryParams = (query) => {
  if (!window.history.replaceState) return;
  let url = new URL(window.location.toString());
  const params = new URLSearchParams(url.search);
  Object.keys(query).forEach((key) => {
    params.set(key, query[key]);
  });
  url.search = params.toString();
  url = url.toString();
  window.history.replaceState({ url }, document.title, url);
};

export const getQueryParam = (key) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key)?.toString();
};

export const removeQueryParams = (paramsToRemove = []) => {
  if (!window.history.replaceState) return;
  let url = new URL(window.location.toString());
  const params = new URLSearchParams(url.search);
  
  paramsToRemove.forEach(item => {
    params.delete(item);
  });

  url.search = params.toString();
  url = url.toString();
  window.history.replaceState({ url }, document.title, url);
}